const LAYOUT = {
  SET_LAYOUT_DATA: 'layout/set_data',
};

const initialState = {};

export const setLayoutData = (data) => ({
  type: LAYOUT.SET_LAYOUT_DATA,
  payload: data,
});

const layoutReducer = (state = initialState, action) => {
  switch (action.type) {
    case LAYOUT.SET_LAYOUT_DATA:
      return {
        ...state,
        ...action.payload,
      };

    default:
      return state;
  }
};

export default layoutReducer;
